var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(3398 3248)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 32,
    height: 32,
    transform: "translate(-3398 -3248)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M15.235,5.529h4.412V7.294H17.882V18.765a.882.882,0,0,1-.882.882H4.647a.882.882,0,0,1-.882-.882V7.294H2V5.529H6.412V2.882A.882.882,0,0,1,7.294,2h7.059a.882.882,0,0,1,.882.882ZM8.176,9.941v5.294H9.941V9.941Zm3.529,0v5.294h1.765V9.941ZM8.176,3.765V5.529h5.294V3.765Z",
    transform: "translate(-3392.823 -3242.823)",
    fill: "#787c7c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.735cb0f7a9ea633d01add623a8341ba2.svg";
export { ForwardRef as ReactComponent };